export default {"src":"/_next/static/media/bus.3c1341e2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};